module.exports = __webpack_public_path__ + "static/img/Architecture_DataAgent_image.10321461.png";